<template>
  <status
    :error="!!invoice.date_cancelled"
    error-text="Cancelled"
    :positive="!!invoice.date_approved || !!invoice.is_draft"
    :positive-color="positiveColor"
    :positive-text="positiveText"
    negative-text="Awaiting Approval"
  />
</template>

<script setup lang="ts">
import type { Invoice } from '@quotetome/materials-api'
import Status from '@/components/status.vue'

export interface Props {
  invoice: Invoice
}

const props = defineProps<Props>()

const positiveColor = computed(() => {
  if (props.invoice.date_processed || props.invoice.is_draft) return 'light-grey'
  return undefined
})

const positiveText = computed(() => {
  if (props.invoice.date_processed) return 'Processed'
  if (props.invoice.is_draft) return 'Draft'
  return 'Approved'
})
</script>
